module.exports = __webpack_public_path__ + "static/media/protect.bda0b596.svg";